import axios from "axios";
import { requiredParam } from "@utils/func";

const getCompanyFirebaseToken = ({
  companyId = requiredParam("companyId"),
}) => {
  return axios.get(`companies/${companyId}/firebase-token`).then((response) => {
    return response.data["firebase_token"];
  });
};

export { getCompanyFirebaseToken };
